import { useQuery } from "@tanstack/react-query";
import { portfolioApi } from "../api/portfolio";

export const useFetchPortfoliosList = () => {
  const { data, isError, isSuccess, isLoading, error } = useQuery({
    queryKey: ["portfolios-list"],
    queryFn: portfolioApi.fetchPortfoliosList,
  });

  return { data: isSuccess ? data?.data : [], isError, isLoading, error };
};